import PropTypes from 'prop-types';
import React from 'react';

const TableDetail = (props) => {
  return (
    <table className={`tw-w-full lex-table-info lex-table-info--auto-header tw-drop-shadow${props.duplicates ? ' lex-table-info--duplicates' : ''}`} style={{ tableLayout: 'fixed' }}>
      <thead>
        <tr>
          {
            props.headers.map((header, index) =>
              <th key={`th-${index}`}>{header}</th>
            )
          }
        </tr>
      </thead>
      <tbody>
        {
          props.rows.map((row, index) =>
            <tr key={`tr-${index}`}>
              {
                row.map((cell, index) =>
                  <td key={`td-${index}`} dangerouslySetInnerHTML={{__html: cell }}></td>
                )
              }
            </tr>
          )
        }
      </tbody>
    </table>
  );
};

TableDetail.propTypes = {
  duplicates: PropTypes.bool,
  headers: PropTypes.array,
  rows: PropTypes.array,
};

TableDetail.defaultProps = {
  duplicates: false,
};

export default TableDetail;
